var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed top-0 left-0 w-screen h-screen-safe"},[(_vm.artwork)?_c('iframe',{staticClass:"w-full h-full",attrs:{"src":_vm.artwork.artwork_url}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }